import React from "react";
import { Modal, Form, Col, FormGroup, Row, FormLabel } from "react-bootstrap";
import { labels } from "../../../../localization/labels";
import SubmitButton from "../../../core/SubmitButton";
import DropDown from "../../../core/DropDown";

const Settings = ({
  show,
  handleClose,
  onSave,
  onChange,
  languages,
  party
}) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>{labels.settings}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="isoLanguage" as={Row}>
            <FormLabel column sm="2" className="control-label">
              {labels.language}
            </FormLabel>
            <Col sm="10">
              <DropDown
                value={party ? party.isoLanguage : undefined}
                options={languages.map(x => ({
                  value: x,
                  label: x.name
                }))}
                onChange={onChange}
                targetId={"isoLanguage"}
                placeholder={labels.language}
              />
            </Col>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <SubmitButton type="close" onClick={handleClose} showLoader={false} />
          <SubmitButton type="save" onClick={onSave} />
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default Settings;
